export const shuffle = arr => arr.sort(() => Math.random() - 0.5)

export const addIconPrefixes = (iconNames, prefix) =>
  iconNames.map(iconName => `${prefix}${iconName}`)
